// import { QueryReturnValue } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import { FetchBaseQueryError, FetchBaseQueryMeta, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_HEADERS, ENDPOINTS } from '../../constants/api';
import { baseQueryWithAuthCheck } from './helper';
import { callFromMiddleware, extractBaseServer, extractDomain } from '../../utils';
import { LoginResponse } from '../../types/api-response';

type ResponseData = {
    loginData?: LoginResponse,
}

type QueryResponseReturnValue<T = unknown, E = unknown, M = unknown> = {
    error: E;
    data?: undefined;
    meta?: M;
} | {
    error?: undefined;
    data: T;
    meta?: M;
};

const baseQuery = fetchBaseQuery({
    baseUrl: window.location.origin,
    headers: {...API_HEADERS,
        'baseserver': extractBaseServer(window.location.host)
    },
    credentials: "include"
});

export const loginApi = createApi({
    reducerPath: 'login',
    baseQuery: baseQueryWithAuthCheck(baseQuery),
    tagTypes: [],
    endpoints: (builder) => ({
        login: builder.query<ResponseData, any>({
            async queryFn(arg, queryApi, extraOptions, fetchWithBQ) {
                const response: QueryResponseReturnValue<ResponseData, FetchBaseQueryError, FetchBaseQueryMeta> = {
                    data: {
                        loginData: undefined,
                    },
                }

                try {
                    const domain = extractDomain();
                    const loginUrl = callFromMiddleware(ENDPOINTS.getUserData + "?domain=" + domain);
                    const loginData = await fetchWithBQ(loginUrl);

                    if (loginData.error) {
                        throw (loginData.error)
                    }

                    response.data.loginData = loginData.data as LoginResponse;
                    sessionStorage.setItem("userDetails", JSON.stringify(loginData.data));
                    return response;
                } catch (error) {
                    console.error("loginError", error);
                    return {
                        error: error as FetchBaseQueryError
                    }
                }
            }
        }),

    }),
})

export const {
    useLoginQuery
} = loginApi

export default loginApi;